import React, { useEffect, useState } from "react";
import "./style.css"; // Import the CSS file
import ProgressBar from "../../ProgressBarStep";
import { State, City } from "country-state-city";

const PersonalInfo = ({
  text,
  formData,
  setFormData,
  isEditing,
  // setIsEditing,
  errors,
  setErrors,
  handleMouseOutForPinCode,
  // handleFirstName,
  // handleLastName,
  // handleWhatsAppNumber,
  handleFormFieldChange,
  userOnboardingDetails,
  userOnboardingQuestions,
  questionSequenceNumber,
  isRequireFields,
}) => {
  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      referralCode: "",
    }));
  }, []);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(""); // Holds the selected state
  const [cities, setCities] = useState([]); // Holds the cities based on the selected

  // Fetch states when the component mounts
  useEffect(() => {
    const stateData = State.getStatesOfCountry("IN"); // Retrieve states for a specific country (IN for India)
    if (stateData && Array.isArray(stateData)) {
      setStates(stateData);
    } else {
      console.log("Failed to retrieve states");
    }
  }, []);

  // Fetch cities when a state is selected
  useEffect(() => {
    if (selectedState) {
      const cityData = City.getCitiesOfState("IN", selectedState); // Retrieve cities for the selected state
      if (cityData && Array.isArray(cityData)) {
        setCities(cityData);
      } else {
        console.log("Failed to retrieve cities");
      }
    }
  }, [selectedState]);

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "referralCode") {
      if (value?.length == 6) {
        handleFormFieldChange();
      }
    }
    if (name === "whatsAppNumber" || name == "pinCode") {
      // Remove any non-numeric characters
      const numericValue = value.replace(/\D/g, ""); // Keep only digits
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue === "" ? null : numericValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value === "" ? null : value,
      }));
    }

    // Clear the specific error for the field being edited
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  return (
    <>
      <div className="mainContainer">
        <h4 className="h4-text">{text}</h4>

        <div className="formContainerPersonal">
          <ProgressBar currentStep={0} />
          <form className="formDivPersonal">
            <div className="questionsPersonal">
              <p className="paraPersonal">
                1. What is your name?{" "}
                {isRequireFields?.firstName == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>

              {/* <p className="paraPersonal">1. {userOnboardingQuestions.firstName}</p> */}
              {/* <input
                type="text"
                id="fullName"
                name="fullName"
                placeholder="Enter your name"
                value={formData.fullName}
                onChange={handleInputChange}
              />
              {errors.fullName && (
                <div className="error">{errors.fullName}</div>
              )} */}

              <div className="twoInputRow">
                <div className="inputContainer">
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="Enter your first name"
                    // value={
                    //   isEditing.firstName
                    //     ? formData.firstName
                    //     : formData.firstName ||
                    //       userOnboardingDetails?.firstName ||
                    //       ""
                    // }
                    value={formData?.firstName}
                    onChange={handleInputChange}
                    className={errors.firstName ? "error-input" : "input"} // Apply error class
                    onBlur={handleFormFieldChange}
                  />

                  {errors.firstName && (
                    <div className="error">{errors.firstName}</div>
                  )}
                </div>

                <div className="inputContainer">
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Enter your last name"
                    // value={
                    //   isEditing.lastName
                    //     ? formData.lastName
                    //     : formData.lastName ||
                    //       userOnboardingDetails?.lastName ||
                    //       ""
                    // }
                    value={formData?.lastName}
                    onChange={handleInputChange}
                    className={errors.lastName ? "error-input" : "input"} // Apply error class
                    onBlur={handleFormFieldChange}
                  />
                  {errors.lastName && (
                    <div className="error">{errors.lastName}</div>
                  )}
                </div>
              </div>
            </div>
            {/* </div> */}

            <div className="questionsPersonal">
              {/* <p className="paraPersonal">2. Enter your whatsapp number *</p> */}
              <p className="paraPersonal">
                2. {/* {questionSequenceNumber.whatAppNumber}.{" "} */}
                {userOnboardingQuestions.whatAppNumber ||
                  "Enter your whatsapp number?"}{" "}
                {isRequireFields?.whatAppNumber == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
              <input
                type="tel"
                maxLength={10}
                id="whatsAppNumber"
                name="whatsAppNumber"
                placeholder="Enter your whatsapp number"
                // value={
                //   isEditing.whatsAppNumber
                //     ? formData.whatsAppNumber
                //     : formData.whatsAppNumber ||
                //       userOnboardingDetails?.whatsAppNumber ||
                //       ""
                // }
                value={formData.whatsAppNumber || ""}
                onChange={handleInputChange}
                className={errors.whatsAppNumber ? "error-input" : "input"} // Apply error class
                onBlur={handleFormFieldChange}
              />
              {errors.whatsAppNumber && (
                <div className="error">{errors.whatsAppNumber}</div>
              )}
            </div>
            {/* <div className="questionsPersonal">
              <p className="paraPersonal">
                3.
                {userOnboardingQuestions.userEmail ||
                  "What is your email address?"}{" "}
                {isRequireFields?.userEmail == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
              <input
                type="email"
                id="userEmail"
                name="userEmail"
                maxLength={50}
                placeholder="Enter your email address"
                value={formData.userEmail}
                onChange={handleInputChange}
                className={errors.email ? "error-input" : "input"}
                onBlur={handleFormFieldChange}
              />
              {errors.userEmail && (
                <div className="error">{errors.userEmail}</div>
              )}
            </div> */}

            <div className="questionsPersonal">
              {/* <p className="paraPersonal">4. What is your address? *</p> */}
              <p className="paraPersonal">
                3. {/* {questionSequenceNumber.address}.{" "} */}
                {userOnboardingQuestions.address ||
                  "What is your address?"}{" "}
                {isRequireFields?.address == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
              {/* ✅ Address — full width */}
              <div className="inputContainer">
                <input
                  type="text"
                  id="address"
                  name="address"
                  placeholder="Address"
                  value={formData.address}
                  onChange={handleInputChange}
                  className={errors.address ? "error-input" : "input"}
                  onBlur={handleFormFieldChange}
                />
                {errors.address && (
                  <div className="error">{errors.address}</div>
                )}
              </div>

              {/* ✅ City + District */}
              <div className="twoInputRow">
                <div className="inputContainer">
                  <input
                    type="text"
                    id="city"
                    name="city"
                    maxLength={50}
                    placeholder="City"
                    value={formData.city}
                    onChange={handleInputChange}
                    className={errors.city ? "error-input" : "input"}
                    onBlur={handleFormFieldChange}
                  />
                  {errors.city && <div className="error">{errors.city}</div>}
                </div>
                <div className="inputContainer">
                  <input
                    type="text"
                    id="district"
                    name="district"
                    maxLength={50}
                    placeholder="District"
                    value={formData.district}
                    onChange={handleInputChange}
                    className={errors.district ? "error-input" : "input"}
                    onBlur={handleFormFieldChange}
                  />
                  {errors.district && (
                    <div className="error">{errors.district}</div>
                  )}
                </div>
              </div>

              {/* ✅ State + Pincode side by side */}
              <div className="twoInputRow">
                <div className="inputContainer">
                  <input
                    type="text"
                    id="state"
                    name="state"
                    placeholder="State"
                    maxLength={50}
                    value={formData.state}
                    onChange={handleInputChange}
                    className={errors.state ? "error-input" : "input"}
                    onBlur={handleFormFieldChange}
                  />
                  {errors.state && <div className="error">{errors.state}</div>}
                </div>
                <div className="inputContainer">
                  <input
                    type="text"
                    id="pinCode"
                    name="pinCode"
                    placeholder="Pin code"
                    maxLength={6}
                    value={formData.pinCode || ""}
                    onChange={handleInputChange}
                    className={errors.pinCode ? "error-input" : "input"}
                    onBlur={(e) => {
                      handleMouseOutForPinCode(e);
                      handleFormFieldChange(e);
                    }}
                  />
                  {errors.pinCode && (
                    <div className="error">{errors.pinCode}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="questionsPersonal">
              {/* <p className="paraPersonal">5. Do you have a referral code? </p> */}
              <p className="paraPersonal">
                4.{" "}
                {userOnboardingQuestions.referralCode ||
                  "Do you have a referral code?"}{" "}
                {isRequireFields?.referralCode == true ? (
                  <span className="asterisk-personal-info">*</span>
                ) : (
                  ""
                )}
              </p>
              <input
                type="text"
                id="referralCode"
                name="referralCode"
                placeholder="Enter referral code"
                maxLength={10}
                // value={
                //   isEditing.referralCode
                //     ? formData.referralCode
                //     : formData.referralCode ||
                //       userOnboardingDetails?.referralCode ||
                //       ""
                // }
                value={formData?.referralCode}
                onChange={handleInputChange}
                // onMouseLeave={handleFormFieldChange}
                className="input"
                // className={errors.referralCode ? "error-input" : "input"} // Apply error class
              />
            </div>
            {errors?.referralCode && (
              <div className="error">{errors?.referralCode}</div>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default PersonalInfo;
